import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { normalizeImageUrl } from '../utils/imageUtils';
import dayjs from 'dayjs';
import { useData } from '../context/DataContext';

const EventsPage = () => {
    const { events, loading } = useData();

    useEffect(() => {
        // Events are now handled globally
    }, []);

    return (
        <main style={{ paddingBottom: 60, borderBottom: '1px solid #ececec' }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4 text-left">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item">
                                <Link to="/gioi-thieu/ve-chung-toi" className="hover:text-red-600 transition-colors no-underline text-slate-500">Giới thiệu</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Sự Kiện
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '0 0 16px' }}>
                    <span>Sự Kiện Trung Anh Garage</span>
                </h1>
                <p className="text-center text-muted mb-5 mx-auto" style={{ maxWidth: 700 }}>
                    Khám phá các chương trình ưu đãi, sự kiện cộng đồng và các hoạt động đặc biệt tại hệ thống Trung Anh Garage.
                </p>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-danger" role="status" />
                        <p className="mt-3 text-muted">Đang tải danh sách sự kiện...</p>
                    </div>
                ) : events.length === 0 ? (
                    <div className="text-center py-5 bg-light rounded-4 border border-dashed">
                        <p className="text-muted mb-0" style={{ fontSize: 16 }}>Hiện chưa có sự kiện nào đang diễn ra.</p>
                    </div>
                ) : (
                    <div className="row g-4 mt-2">
                        {events.map(event => (
                            <div key={event._id || event.id} className="col-12 col-md-6 col-lg-4">
                                <Link 
                                    to={`/su-kien/${event.slug}`} 
                                    className="event-card-link"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <div
                                        className="h-100"
                                        style={{
                                            background: '#fff', 
                                            borderRadius: 16, 
                                            overflow: 'hidden',
                                            boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                                            transition: 'all 0.3s ease',
                                            border: '1px solid #f0f0f0',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-6px)';
                                            e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.12)';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.05)';
                                        }}
                                    >
                                        {/* Image wrapper */}
                                        <div style={{ position: 'relative', height: 210, overflow: 'hidden' }}>
                                            {event.imageUrl ? (
                                                <img
                                                    src={normalizeImageUrl(event.imageUrl)}
                                                    alt={event.title}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <div style={{ 
                                                    width: '100%', height: '100%', 
                                                    background: '#f8f9fa', 
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    color: '#dee2e6' 
                                                }}>
                                                    <i className="bi bi-calendar-event" style={{ fontSize: 40 }}></i>
                                                </div>
                                            )}
                                            
                                            {/* Date Badge overlay */}
                                            <div style={{
                                                position: 'absolute',
                                                bottom: 12,
                                                left: 12,
                                                background: 'rgba(0,0,0,0.6)',
                                                backdropFilter: 'blur(4px)',
                                                color: '#fff',
                                                padding: '4px 12px',
                                                borderRadius: 8,
                                                fontSize: 11,
                                                fontWeight: 600,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 6
                                            }}>
                                                <span>{dayjs(event.eventStartDate).format('DD/MM/YYYY')}</span>
                                                <span style={{ opacity: 0.6 }}>→</span>
                                                <span>{dayjs(event.eventEndDate).format('DD/MM/YYYY')}</span>
                                            </div>
                                        </div>

                                        {/* Content container */}
                                        <div style={{ padding: 20, flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <h3 style={{ 
                                                fontSize: 17, 
                                                fontWeight: 700, 
                                                color: '#1a1a1a', 
                                                lineHeight: 1.4,
                                                marginBottom: 12,
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                height: '2.8em'
                                            }}>
                                                {event.title}
                                            </h3>
                                            
                                            {/* Time status line */}
                                            <div style={{ 
                                                fontSize: 13, 
                                                color: '#666', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: 6,
                                                marginBottom: 15
                                            }}>
                                                {(() => {
                                                    const now = dayjs();
                                                    const start = dayjs(event.eventStartDate);
                                                    const end = dayjs(event.eventEndDate);
                                                    
                                                    if (now.isBefore(start)) {
                                                        return (
                                                            <>
                                                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#f59e0b' }}></span>
                                                                Sắp diễn ra
                                                            </>
                                                        );
                                                    } else if (now.isAfter(end)) {
                                                        return (
                                                            <>
                                                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#94a3b8' }}></span>
                                                                Đã kết thúc
                                                            </>
                                                        );
                                                    } else {
                                                        return (
                                                            <>
                                                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e' }}></span>
                                                                Đang diễn ra
                                                            </>
                                                        );
                                                    }
                                                })()}
                                            </div>

                                            <div style={{ 
                                                marginTop: 'auto',
                                                color: '#ff0000',
                                                fontWeight: 700,
                                                fontSize: 14,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 4
                                            }}>
                                                Xem chi tiết <span style={{ fontSize: 18 }}>›</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </main>
    );
};

export default EventsPage;





